export default function ServicesComp() {
  return (
    <div className="small_basket_type">
      <h2>Services</h2>
      <p>
        This is the services page this is the services page this is the services
        page this is the services page this is the services page. This is the
        services page this is the services page this is the services page this
        is the services page this is the services page. This is the services
        page this is the services page this is the services page this is the
        services page this is the services page. This is the services page this
        is the services page this is the services page this is the services page
        this is the services page. This is the services page this is the
        services page this is the services page this is the services page this
        is the services page.
      </p>
      <p>
        This is the services page this is the services page this is the services
        page this is the services page this is the services page. This is the
        services page this is the services page this is the services page this
        is the services page this is the services page. This is the services
        page this is the services page this is the services page this is the
        services page this is the services page. This is the services page this
        is the services page this is the services page this is the services page
        this is the services page. This is the services page this is the
        services page this is the services page this is the services page this
        is the services page.
      </p>
      <p>
        This is the services page this is the services page this is the services
        page this is the services page this is the services page. This is the
        services page this is the services page this is the services page this
        is the services page this is the services page. This is the services
        page this is the services page this is the services page this is the
        services page this is the services page. This is the services page this
        is the services page this is the services page this is the services page
        this is the services page. This is the services page this is the
        services page this is the services page this is the services page this
        is the services page.
      </p>
    </div>
  );
}
